<script lang="ts">
    import { onMount } from "svelte";
    import Container from "../../../../components/Container.svelte";
    import Gap from "../../../../components/Gap.svelte";
    import LightTheme from "../../../../components/LightTheme.svelte";
    import type { News } from "../../../../components/NewsCard.svelte";
    import PageTransition from "../../../../components/PageTransition.svelte";
    import Image from "../../../../components/Image.svelte";
    import Hero from "../../../../components/Hero.svelte";
    import IdeaInfo from "../../../../components/IdeaInfo.svelte";
    import Divider from "../../../../components/Divider.svelte";
    import type { ProjectPreview } from "../../../../components/ProjectPreviews.svelte";
    import { params } from "@roxi/routify";
    import Headline from "../../../../components/Headline.svelte";
    import Subline from "../../../../components/Subline.svelte";
    import { t } from "../../../../helpers/translation";

    export let url: string;

    type EventDate = ProjectPreview & {
        id: number;
        title: string;
        url: string;
        startdate: string;
        enddate: string;
        image: string;
        bodyhtml: string;
        iframehtml: string;
        hidden: boolean;
        date: string;
    };

    const loadData = async (): Promise<EventDate> => {
        const data: EventDate = await fetch(
            `/api/termine/${$params.id}/${$params.url}`,
        )
            .then((data) => data.json())
            .then((data) => {
                data.date =
                    new Date(data.startdate).toLocaleDateString() +
                    " - " +
                    new Date(data.enddate).toLocaleDateString();
                return data;
            })
            .catch((err) => console.error(err));

        return data ? Promise.resolve<EventDate>(data) : Promise.reject(null);
    };
</script>

<LightTheme />

{#await loadData()}
    {$t("fetch.post.loading")}
{:then data}
    <Hero
        small
        bgimg={data.image ||
            "https://liveicom.azureedge.net/sinus/img/hero-wave-green.jpg"}
        headline=""
    />

    <Container>
        <Headline>{data.title}</Headline>
        <!-- {#if data.subline}
            <Subline>{data.subline}</Subline>
        {/if} -->
        <Divider gap="2rem" />
        <time>
            {new Date(data.startdate).toLocaleDateString()} -
            {new Date(data.enddate).toLocaleDateString()}
        </time>
        <article>
            {@html data.bodyhtml}
        </article>
        <!-- <IdeaInfo>
            random suggestions?
            <pre>
select top 3 * from [tablename] order by newid()
select top 1 percent * from [tablename] order by newid()</pre>
        </IdeaInfo> -->
    </Container>
{:catch}
    {$t("fetch.post.error")}
{/await}

<style lang="scss">
    @import "../../../../vars";

    h1 {
        font-size: 2.5rem;
        font-weight: 600;
        line-height: 1.2;
    }
</style>
